import { Provider } from '@angular/core';
import { NotificationInboxService } from 'nera-common/angular';
import { NotificationsService } from 'app/core/services/notifications.service';

/**
 * DI registration for nera-common's SHARED notification inbox client.
 *
 * The shared class is deliberately UNDECORATED — nera-common's `angular`
 * subpath is compiled with plain `tsc`, which cannot emit the partial-Ivy
 * output an `@Injectable()` needs — so the CONSUMING app has to register it.
 *
 * The app's own `NotificationsService` IS that client (it extends it and adds
 * the bell's state layer), so the shared type is bound to that instance
 * instead of creating a second one: `NotificationInboxService` and
 * `NotificationsService` resolve to the SAME object.
 */
export function provideNotificationInbox(): Provider {
    return {
        provide: NotificationInboxService,
        useExisting: NotificationsService,
    };
}
